document.addEventListener('DOMContentLoaded', function () {
  var bars = document.querySelectorAll('.trust-cycle__inner');

  bars.forEach(function (bar) {
    var items = bar.querySelectorAll('.trust-cycle__item');
    if (items.length <= 1) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
    var index = 0;

    setInterval(function () {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, interval);
  });
});